var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "search_form",
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "输入搜索：",
                                  prop: "search_type"
                                }
                              },
                              [
                                _vm.resData
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "搜索条件" },
                                        model: {
                                          value: _vm.form.search_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "search_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.search_type"
                                        }
                                      },
                                      _vm._l(_vm.searchOption, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "keyword" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "关键字" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.keyword,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "keyword", $$v)
                                    },
                                    expression: "form.keyword"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "create_admin" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "创建人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.create_admin,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_admin", $$v)
                                    },
                                    expression: "form.create_admin"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "receive_admin" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "领取人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.receive_admin,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "receive_admin", $$v)
                                    },
                                    expression: "form.receive_admin"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "status" } },
                              [
                                _vm.resData
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.statusOption, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "receive_admin" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "波次号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.wave_picking_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wave_picking_no", $$v)
                                    },
                                    expression: "form.wave_picking_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "创建时间：",
                                  prop: "create_time"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "领取时间：",
                                  prop: "receive_time"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.receive_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "receive_time", $$v)
                                    },
                                    expression: "form.receive_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "开始时间：",
                                  prop: "start_time"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.start_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "start_time", $$v)
                                    },
                                    expression: "form.start_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "完成时间：",
                                  prop: "complete_time"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.complete_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "complete_time", $$v)
                                    },
                                    expression: "form.complete_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "提交时间：",
                                  prop: "submit_time"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "default-time": ["06:00:00", "06:00:00"],
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.submit_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "submit_time", $$v)
                                    },
                                    expression: "form.submit_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "close_admin" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "是否后台关闭" },
                                    model: {
                                      value: _vm.form.close_admin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "close_admin", $$v)
                                      },
                                      expression: "form.close_admin"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { value: "1", label: "是" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { value: "2", label: "否" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "task_type" } },
                              [
                                _vm.resData
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "任务类型" },
                                        model: {
                                          value: _vm.form.task_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "task_type", $$v)
                                          },
                                          expression: "form.task_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.taskTypeOption, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.search_form.resetFields()
                                      }
                                    }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.closeBox }
                  },
                  [_vm._v("\n          批量关闭容器")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output(2)
                      }
                    }
                  },
                  [_vm._v("\n          导出上架单明细")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.output(1)
                      }
                    }
                  },
                  [_vm._v("\n          导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        attrs: {
                          height: "600",
                          data: _vm.resData.data,
                          "tooltip-effect": "dark",
                          "cell-style": { padding: "2px 0" }
                        },
                        on: { "selection-change": _vm.handleSelection }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { align: "center", type: "selection" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "us_no",
                            label: "上架单号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120",
                            fixed: "left"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "task_type",
                            label: "任务类型",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "box_no",
                            label: "容器号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openBarCode(
                                              scope.row.box_no
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row.box_no) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3966866579
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_name",
                            label: "创建人",
                            width: "100",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "创建时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "任务数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num_ok",
                            label: "已上架数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wave_picking_no",
                            label: "波次号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receive_name",
                            label: "领取人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receive_time",
                            label: "领取时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "start_time",
                            label: "开始上架时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "submit_time",
                            label: "提交时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "complete_time",
                            label: "完成时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "任务待领取时长",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.create_time
                                      ? _c("div", [
                                          scope.row.status ===
                                          _vm.UPSHELF_STATUS.UNRECEIVED
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      Math.ceil(
                                                        (_vm.dayjs().unix() -
                                                          _vm
                                                            .dayjs(
                                                              scope.row
                                                                .create_time
                                                            )
                                                            .unix()) /
                                                          60
                                                      )
                                                    ) +
                                                    "分钟\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.status ===
                                            _vm.UPSHELF_STATUS.RECEIVED &&
                                          scope.row.receive_time
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      Math.ceil(
                                                        (_vm
                                                          .dayjs(
                                                            scope.row
                                                              .receive_time
                                                          )
                                                          .unix() -
                                                          _vm
                                                            .dayjs(
                                                              scope.row
                                                                .create_time
                                                            )
                                                            .unix()) /
                                                          60
                                                      )
                                                    ) +
                                                    "分钟\n                "
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4163009686
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "upshelf_status",
                            label: "状态",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "is_admin_close",
                            label: "是否后台关闭",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exception_name",
                            label: "异常处理人员",
                            width: "100",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "exception_time",
                            label: "异常处理时间",
                            width: "180",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "except",
                            label: "异常数据",
                            width: "120",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "package_no",
                            label: "点货包裹",
                            width: "120",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            prop: "goods_name",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status == 3
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.unbind(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("解绑")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showDbids(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("\n                详情")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3922149290
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper, sizes ",
                        total: _vm.resData.total,
                        "page-size": 10,
                        "page-sizes": [10, 50, 100, 200]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("上架任务")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9f91f8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9f91f8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UpshelfList.vue
// module id = null
// module chunks = 